<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";
import { useFormField } from "./useFormField";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});

const { error, formMessageId } = useFormField();

const body = computed(() => error.value);
</script>

<template>
  <p
    v-if="body"
    :id="formMessageId"
    data-slot="form-message"
    :class="cn('text-destructive text-xs mt-1', props.class)"
  >
    {{ body }}
  </p>
</template>
